import React from "react";

import asIcon from "./asIcon";

export default asIcon(
  ({ color }) =>
    <path fill={color} d="M45,67.5c0.8,0,1.2-0.2,2-0.8l14.8-15c0.5-0.5,0.7-1,0.7-1.8c0-0.8-0.2-1.5-0.7-2L47,33.2c-0.5-0.5-1.2-0.8-2-0.8s-1.2,0.2-2,0.8c-0.5,0.5-0.7,1-0.7,1.8s0.2,1.5,0.7,2l12,13L43,63c-0.5,0.5-0.7,1.2-0.7,2s0.2,1.2,0.7,2C43.8,67.2,44.5,67.5,45,67.5z" />,
);
